module.exports = __webpack_public_path__ + "img/gift-renegades.9966396.png";